import * as yup from 'yup'

const requiredMessage = 'Please select or create a facility.'

export interface IFacilityBase {
  id?: number
  name: string
}

/**
 * Schema that allows for passing one of two objects
 * depending on whether the facility is new or existing
 * @see https://fp-staging.transfix.io/api-docs/index.html#/Shipments/post_shipments
 */
export const ShipmentStopFacilitySchema = yup.object<IFacilityBase>({
  id: yup.number().notRequired(),
  name: yup.string().required(requiredMessage),
})
